import { groupByValue } from './Operations/GroupOperation.js'
import {
  filterContains,
  filterDateRange,
  filterDuration,
  filterInList,
  filterIsNotUnset,
  filterIsUnset,
  filterNotInList
} from './Operations/FilterOperations.js'
import { projectMonthYear, projectQuarter, projectYear } from './Operations/ProjectionOperations.js'
import { keyByKeyedObject } from './MetadataFields.js'
import { sortAscending, sortDescending } from './Operations/SortByOperations.ts'

export const OPERATIONS = [
  filterIsUnset,
  groupByValue,
  filterIsNotUnset,
  filterContains,
  filterInList,
  filterNotInList,
  filterDateRange,
  filterDuration,
  projectMonthYear,
  projectQuarter,
  projectYear,
  sortAscending,
  sortDescending
] as const

export type OperationKeys = (typeof OPERATIONS)[number]['key']
export type FilterOperationKey = Extract<(typeof OPERATIONS)[number], { type: 'filter' }>['key']
export type GroupByOperationKey = Extract<(typeof OPERATIONS)[number], { type: 'groupBy' }>['key']
export type ProjectionOperationKey = Extract<(typeof OPERATIONS)[number], { type: 'projection' }>['key']
export type SortByOperationKey = Extract<(typeof OPERATIONS)[number], { type: 'sort' }>['key']

export const OPERATION_REGISTRY = keyByKeyedObject<OperationKeys, (typeof OPERATIONS)[number]>(OPERATIONS)

/**
 * Keyed lookup widens to the whole operation union, so the discriminant does the narrowing — grouping
 * is the one category carrying a `stringify`. A key typed as a grouping cannot resolve to anything else;
 * the throw covers a registry entry whose `type` stopped matching the list it was pulled from.
 */
export const groupByOperation = (key: GroupByOperationKey) => {
  const operation = OPERATION_REGISTRY[key]
  if (operation.type !== 'groupBy') {
    throw new Error(`Operation ${key} is registered as ${operation.type}, not a grouping`)
  }
  return operation
}
